/**
 * Derive the CloudHub "manage account" URL from the CloudHub docs base URL.
 *
 * The docs base URL always has a docs-specific subdomain label as its first
 * hostname segment (e.g. "documentation-user-manual-api" or "documentation").
 * The manage-account host is "my." followed by the REMAINING domain labels,
 * so we drop only that first label rather than assuming a fixed domain length.
 *
 * Examples:
 *   https://documentation-user-manual-api.pantaris-latest.de/v1
 *     -> https://my.pantaris-latest.de/settings/account
 *   https://documentation-user-manual-api.cloudhub.etas.com/v1
 *     -> https://my.cloudhub.etas.com/settings/account
 *   https://documentation.pantaris.io
 *     -> https://my.pantaris.io/settings/account
 */
export function getManageAccountUrl(docsBaseUrl: string): string {
  try {
    const docsUrl = new URL(docsBaseUrl);
    // Drop the first label (docs subdomain), keep the rest of the domain
    const domain = docsUrl.hostname.split('.').slice(1).join('.');
    if (!domain) {
      throw new Error(`Unable to derive domain from hostname: ${docsUrl.hostname}`);
    }
    return `https://my.${domain}/settings/account`;
  } catch {
    // Fallback to production if URL parsing fails
    return 'https://my.pantaris.io/settings/account';
  }
}
